import React, { Fragment, useState } from "react";
import DataTableComponent from "../Shared/Table";
import styles from "./brandstyles.module.scss";
import DropdownIcon from "../../assets/images/arrow-square-down.svg";
import SortIcon from "../../assets/images/sort-icon.svg";
import BrandsDetailModal from "./BrandsModals/BrandsDetail";
import StatusDropdown from "./StatusDropdown";
import { format } from "date-fns";
import StatusIndicator from "./StatusIndicator";
import AddBrandModal from "./BrandsModals/AddBrand";
import { useDispatch, useSelector } from "react-redux";
import {
  clearBrandSearch,
  searchBrands,
  sortBrands,
} from "../Redux/Reducer/appReducer";
import CuteMascotSpinner from "../../global/CuteMascotSpinner";
import PageHeader from "../../global/PageHeader/PageHeader";

const BrandPage = () => {
  const [loading, setLoading] = useState(false);
  const [openBrandsDetailModal, setOpenBrandsDetailModal] = useState(false);
  const [openAddBrand, setOpenAddBrand] = useState(false);
  const [currentBrandId, setCurrentBrandId] = useState("");

  const dispatch = useDispatch();
  const { role } = useSelector((state) => state?.authReducer);
  const brandsData = useSelector(
    (state) => state?.appReducer?.brandsSearchResults
  );

  const filteredBrands =
    role === "admin"
      ? brandsData
      : brandsData?.filter((brand) => brand.status.toLowerCase() === "approve");

  const tableData = (filteredBrands || []).map((brandData) => {
    const createdDate = format(
      new Date(brandData?.createdAt),
      "h:mm a M/d/yy"
    )?.split(" ");
    createdDate?.splice(2, 0, "on");
    const dateString = createdDate?.join(" ");
    return {
      ...brandData,
      image: brandData?.image || "",
      name: brandData?.brandName || "",
      status: brandData?.status
        ? brandData?.status.charAt(0).toUpperCase() + brandData?.status.slice(1)
        : "",
      lastUpdated: brandData?.updatedAt
        ? format(new Date(brandData?.updatedAt), "M/d/yy h:mm a z")
        : "",
      industry: brandData?.primaryProductCategory || "",
      createdAt: dateString || "",
    };
  });

  const sortOptions = [
    "Alphabetical (A-Z)",
    "Alphabetical (Z-A)",
    "Last Modified",
  ];

  const handleSearch = (e) => {
    const query = e.target.value;
    if (query.trim() === "") {
      dispatch(clearBrandSearch());
    } else {
      dispatch(searchBrands(query));
    }
  };

  const handleSort = (sortOption) => {
    dispatch(sortBrands(sortOption));
  };

  const manufacturerColumns = [
    {
      name: "Brand Name",
      selector: (row) => row.name,
      sortable: false,
      center: false,
      wrap: true,
      cell: (row) => (
        <div className={styles.brandname_container}>
          <p className={styles.brandname_row_title}>{row.name}</p>
        </div>
      ),
    },
    {
      name: "Industry",
      selector: (row) => row.industry,
      sortable: false,
      center: true,
      minWidth: "35%",
      maxWidth: "35%",
      cell: (row) => (
        <p className={styles.brandname_row_title}>{row.industry}</p>
      ),
    },
    {
      name: "Date Modified",
      selector: (row) => row.lastUpdated,
      sortable: false,
      center: true,
      minWidth: "30%",
      maxWidth: "30%",
      cell: (row) => (
        <p className={styles.brandname_row_title}>{row.lastUpdated}</p>
      ),
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: false,
      center: true,
      minWidth: "15%",
      maxWidth: "15%",
      wrap: true,
      cell: (row) => <StatusIndicator currentStatus={row?.status} />,
    },
  ];

  const menuOptionColumn = {
    name: "",
    selector: (row) => row.action,
    sortable: false,
    center: true,
    minWidth: "4%",
    maxWidth: "4%",
    wrap: true,
    cell: (row) => (
      <StatusDropdown
        brandId={row?.id}
        onComplete={() => {}}
        currentStatus={row?.status}
        setLoading={setLoading}
      />
    ),
  };

  const columns =
    role === "admin"
      ? [...manufacturerColumns, menuOptionColumn]
      : manufacturerColumns;

  return (
    <Fragment>
      {loading && <CuteMascotSpinner />}
      {openAddBrand && (
        <AddBrandModal
          toggle={() => setOpenAddBrand(!openAddBrand)}
          openModal={openAddBrand}
          setLoading={setLoading}
        />
      )}
      {openBrandsDetailModal && (
        <BrandsDetailModal
          openModal={openBrandsDetailModal}
          toggle={() => setOpenBrandsDetailModal(!openBrandsDetailModal)}
          currentBrandId={currentBrandId}
          setLoading={setLoading}
        />
      )}
      <div className={styles.brands_container}>
        <div className={styles.brands_inner_container}>
          <div className={styles._page_header_wrapper}>
            <PageHeader
              title="Brands"
              sortOptions={sortOptions}
              onSearch={handleSearch}
              onSort={handleSort}
              onAdd={() => setOpenAddBrand(true)}
              addButtonLabel="Add Brands"
              SortIcon={SortIcon}
              DropdownIcon={DropdownIcon}
            />
          </div>

          <div className={styles.table_container}>
            <DataTableComponent
              tableColumns={columns}
              tableData={tableData}
              highlightOnHover
              onRowClicked={(row) => {
                setCurrentBrandId(row?.id || "");
                setOpenBrandsDetailModal(true);
              }}
              className={
                tableData?.length > 1 ? "" : styles.table_inner_container
              }
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default BrandPage;

// import React, { Fragment, useState } from "react";
// import DataTableComponent from "../Shared/Table";
// import styles from "./brandstyles.module.scss";
// import DropdownIcon from "../../assets/images/arrow-square-down.svg";
// import SortIcon from "../../assets/images/sort-icon.svg";
// import BrandsDetailModal from "./BrandsModals/BrandsDetail";
// import StatusDropdown from "./StatusDropdown";
// import { format } from "date-fns";
// import StatusIndicator from "./StatusIndicator";
// import AddBrandModal from "./BrandsModals/AddBrand";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   clearBrandSearch,
//   searchBrands,
//   sortBrands,
// } from "../Redux/Reducer/appReducer";
// import CuteMascotSpinner from "../../global/CuteMascotSpinner";
// import PageHeader from "../../global/PageHeader/PageHeader";

// const BrandPage = () => {
//   const [loading, setLoading] = useState(false);
//   const brandsData = useSelector(
//     (state) => state?.appReducer
//   )?.brandsSearchResults;

//   const { role } = useSelector((state) => state?.authReducer);

//   const filteredBrands =
//     role === "admin"
//       ? brandsData
//       : brandsData.filter((brand) => brand.status.toLowerCase() === "approve");

//   const tableData = (filteredBrands || []).map((brandData) => {
//     const createdDate = format(
//       new Date(brandData?.createdAt),
//       "h:mm a M/d/yy"
//     )?.split(" ");
//     createdDate?.splice(2, 0, "on");
//     const dateString = createdDate?.join(" ");
//     return {
//       ...brandData,
//       image: brandData?.image || "",
//       name: brandData?.brandName || "",
//       status: brandData?.status
//         ? brandData?.status.charAt(0).toUpperCase() + brandData?.status.slice(1)
//         : "",
//       updatedAt: brandData?.updatedAt || "",
//       lastUpdated: brandData?.updatedAt
//         ? format(new Date(brandData?.updatedAt), "M/d/yy h:mm a z")
//         : "",
//       industry: brandData?.primaryProductCategory || "",
//       action: "",
//       createdAtData: brandData?.createdAt || "",
//       createdAt: dateString || "",
//       description: brandData?.descriptionOrBrand || "",
//       address:
//         (brandData?.addressLine1 || "") + (brandData?.addressLine2 || "") || "",
//       otherBrands: "Dell Plus, Dell Market, Dell Cuea",
//     };
//   });

//   const userData = useSelector((state) => state.authReducer);
//   const isAdmin = userData?.role === "admin" || false;
//   const sortOptions = [
//     "Alphabetical (A-Z)",
//     "Alphabetical (Z-A)",
//     "Last Modified",
//   ];

//   const [openBrandsDetailModal, setOpenBrandsDetailModal] = useState(false);
//   const [openAddBrand, setOpenAddBrand] = useState(false);
//   const [currentBrandId, setCurrentBrandId] = useState("");

//   const menuOptionColumn = {
//     name: "",
//     selector: (row) => row.action,
//     sortable: false,
//     center: true,
//     minWidth: "4%",
//     maxWidth: "4%",
//     wrap: true,
//     cell: (row) => {
//       return (
//         <div>
//           <StatusDropdown
//             brandId={row?.id}
//             onComplete={() => {}}
//             currentStatus={row?.status}
//             setLoading={setLoading}
//           />
//         </div>
//       );
//     },
//   };
//   const manufacturerColumns = [
//     {
//       name: "Brand Name",
//       selector: (row) => row.name,
//       sortable: false,
//       center: true,
//       wrap: true,
//       cell: (row) => {
//         return (
//           <div className={styles["brandname_container"]}>
//             {/* {row?.images && (
//               <img
//                 src={row?.images[0]}
//                 alt="icon"
//                 width={35}
//                 height={35}
//                 style={{
//                   objectFit: "cover",
//                 }}
//               />
//             )} */}
//             <p
//               // style={{ minWidth: "66px" }}
//               className={styles["brandname_row_title"]}
//             >
//               {row.name}
//             </p>
//           </div>
//         );
//       },
//     },
//     {
//       name: "Industry",
//       selector: (row) => row.industry,
//       sortable: false,
//       center: true,
//       minWidth: "35%",
//       maxWidth: "35%",
//       cell: (row) => {
//         return <p className={styles["brandname_row_title"]}>{row.industry}</p>;
//       },
//     },
//     //#00B533 approved #7167E9 pending #F00 Canceled
//     {
//       name: "Date Modified",
//       selector: (row) => row.lastUpdated,
//       sortable: false,
//       center: true,
//       minWidth: "30%",
//       maxWidth: "30%",
//       cell: (row) => {
//         return (
//           <p className={styles["brandname_row_title"]}>{row.lastUpdated}</p>
//         );
//       },
//     },
//     {
//       name: "Status",
//       selector: (row) => row.status,
//       sortable: false,
//       center: true,
//       minWidth: "15%",
//       maxWidth: "15%",
//       wrap: true,
//       cell: (row) => {
//         return <StatusIndicator currentStatus={row?.status} />;
//       },
//     },
//   ];

//   const columns = isAdmin
//     ? [...manufacturerColumns, menuOptionColumn]
//     : [...manufacturerColumns];

//   const dispatch = useDispatch();
//   const handleSearch = (e) => {
//     const query = e.target.value;
//     if (query.trim() === "") {
//       dispatch(clearBrandSearch()); // Reset search results when the input is empty
//     } else {
//       dispatch(searchBrands(query)); // Filter locations based on the query
//     }
//   };

//   const handleSort = (sortOption) => {
//     dispatch(sortBrands(sortOption)); // Dispatch the action with the selected sort option
//   };

//   return (
//     <Fragment>
//       {loading && <CuteMascotSpinner />}
//       {openAddBrand ? (
//         <AddBrandModal
//           toggle={() => setOpenAddBrand(!openAddBrand)}
//           openModal={openAddBrand}
//           setLoading={setLoading}
//         />
//       ) : null}
//       {openBrandsDetailModal ? (
//         <BrandsDetailModal
//           openModal={openBrandsDetailModal}
//           toggle={() => {
//             setOpenBrandsDetailModal(!openBrandsDetailModal);
//           }}
//           currentBrandId={currentBrandId}
//           setLoading={setLoading}
//         />
//       ) : null}
//       <div className={styles["brands_container"]}>
//         <div className={styles["brands_inner_container"]}>
//           {
//             <>
//               <PageHeader
//                 title="Brands"
//                 sortOptions={sortOptions}
//                 onSearch={handleSearch}
//                 onSort={handleSort}
//                 onAdd={() => setOpenAddBrand(true)}
//                 addButtonLabel="Add Brands"
//                 SortIcon={SortIcon}
//                 DropdownIcon={DropdownIcon}
//                 // AddIcon={AddIcon}
//               />

//               <div className={styles["table_container"]}>
//                 <DataTableComponent
//                   tableColumns={columns}
//                   tableData={tableData}
//                   highlightOnHover={true}
//                   onRowClicked={(row) => {
//                     setCurrentBrandId(row?.id || "");
//                     setOpenBrandsDetailModal(true);
//                   }}
//                   className={
//                     tableData?.length > 1 ? "" : styles["table_inner_container"]
//                   }
//                 />
//               </div>
//             </>
//           }
//         </div>
//       </div>
//     </Fragment>
//   );
// };
// export default BrandPage;
